export default __webpack_public_path__ + "static/media/television.bbb4a965.png";